import { render, staticRenderFns } from "./Transmission.vue?vue&type=template&id=d7e52434&"
import script from "./Transmission.vue?vue&type=script&lang=ts&"
export * from "./Transmission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports